import { render, staticRenderFns } from "./back-button.vue?vue&type=template&id=235823bc&"
import script from "./back-button.vue?vue&type=script&lang=js&"
export * from "./back-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports